import * as React from 'react';
import * as classNames from 'classnames';
import './style.css';

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  /* empty */
}

interface CheckboxState {
  /* empty */
}

export class Checkbox extends React.Component<CheckboxProps, CheckboxState> {
  render() {
    const className = classNames('edge-of-play-checkbox', this.props.className);

    return (
      <div className={className}>
        <input
          {...this.props}
          className="edge-of-play-checkbox-checkbox"
          type="checkbox"
        />
        <div className="edge-of-play-checkbox-visual" />
      </div>
    );
  }
}

export default Checkbox;



// WEBPACK FOOTER //
// ./src/app/components/Forms/Checkbox/index.tsx